export default "__VITE_ASSET__DhEXeUS8__"